import { cn } from '@/utils/helpers';

/**
 * Select/Dropdown component
 */
function Select({ 
  label, 
  value, 
  onChange, 
  options = [], 
  placeholder = 'Select an option',
  error,
  className,
  containerClassName,
  ...props 
}) {
  const hasError = Boolean(error);

  return (
    <div className={cn('space-y-1.5', containerClassName)}>
      {label && (
        <label className="block text-sm font-medium text-gray-700">
          {label}
        </label>
      )}
      
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={cn(
          'w-full px-4 py-3 rounded-lg border bg-white text-gray-900',
          'transition-all duration-200 cursor-pointer',
          'focus:outline-none focus:ring-2 focus:border-transparent',
          hasError && 'border-red-300 focus:ring-red-500',
          !hasError && 'border-gray-200 focus:ring-primary-500',
          className
        )}
        {...props}
      >
        {placeholder && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}
        {options.map((option) => (
          <option 
            key={option.value} 
            value={option.value}
          >
            {option.label}
          </option>
        ))}
      </select>

      {error && (
        <p className="text-sm text-red-500">{error}</p>
      )}
    </div>
  );
}

export default Select;
